/**
 * @module Services/Bff/Presenters/Request/UserBuyIntention
 * @desc User Buy Intention
 *
 */

type TBuyIntentionData = {
  productCode: number;
  quantity: number;
};

/**
 * Transforms the search request payload from the domain to the request options
 *
 */
export function buyIntentionPresenter({ productCode, quantity }: TBuyIntentionData) {
  return { sku: productCode, quantity };
}
